var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "svg",
    {
      attrs: {
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        width: "24",
        height: "24",
        viewBox: "0 0 32 32",
        fill: _vm.color,
      },
    },
    [
      _c("title", [_vm._v("logout")]),
      _vm._v(" "),
      _c("path", {
        attrs: {
          fill: "none",
          "stroke-linejoin": "miter",
          "stroke-linecap": "butt",
          "stroke-miterlimit": "4",
          "stroke-width": "2.6667",
          stroke: _vm.color,
          d: "M18.663 4.639h-12.781c-1.569 0-2.84 1.272-2.84 2.84v17.041c0 1.569 1.272 2.84 2.84 2.84h12.781",
        },
      }),
      _vm._v(" "),
      _c("path", { attrs: { d: "M28.248 14.225v2.84h-17.041v-2.84h17.041z" } }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          fill: "none",
          "stroke-linejoin": "miter",
          "stroke-linecap": "butt",
          "stroke-miterlimit": "4",
          "stroke-width": "2.6667",
          stroke: _vm.color,
          d: "M23.988 10.675l4.97 4.97-4.97 4.97",
        },
      }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }